"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDropEventLandingShortUrl = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const invokeApiRequest_1 = __importDefault(require("root/src/client/logic/api/util/invokeApiRequest"));
const getUserDropEventLandingShortUrl = (dropEventId) => (_, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { body } = yield (0, invokeApiRequest_1.default)(endpointIds_1.GET_USER_DROP_EVENT_LANDING_SHORT_URL, { dropEventId }, state);
    return body;
});
exports.getUserDropEventLandingShortUrl = getUserDropEventLandingShortUrl;
